import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function ArticleGrid() {
  const articles = getLatestArticles(8);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-8 md:mb-12 gap-3">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 mb-2">
              最新爆料
            </h2>
            <p className="text-sm text-foreground-600">全网最热爆料资讯，第一时间为你送达</p>
          </div>
          <Link
            to="/category/wanghong-fanche"
            className="whitespace-nowrap text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 transition-colors duration-200"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex overflow-x-auto gap-4 pb-4 -mx-4 px-4 md:grid md:grid-cols-2 lg:grid-cols-4 md:gap-5 md:overflow-visible md:pb-0 md:px-0 md:-mx-0">
          {articles.map((article) => (
            <article
              key={article.id}
              className="group flex-shrink-0 w-[280px] md:w-auto rounded-lg overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:scale-[1.02]"
            >
              <Link to={`/article/${article.id}`} className="block relative aspect-[4/3] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 right-3">
                  <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium backdrop-blur-sm">
                    <i className="ri-fire-line text-[10px]"></i>
                    {article.hotIndex}°
                  </span>
                </div>
                <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/60 to-transparent"></div>
              </Link>
              <div className="p-4">
                <Link to={`/category/${article.categorySlug}`} className="inline-block text-xs text-primary-600 font-medium mb-2 hover:text-primary-700">
                  {article.category}
                </Link>
                <Link to={`/article/${article.id}`}>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-700 transition-colors duration-200">
                    {article.title}
                  </h3>
                </Link>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views > 10000
                      ? `${(article.views / 10000).toFixed(1)}万`
                      : article.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {article.comments}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.publishedAt.slice(5)}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}